export default {
  SET_ACTIVE_RATES(state, payload) {
    state.actualRates = payload
  }
}